import { Dialog, DialogTitle, Grid } from '@material-ui/core';
import React from 'react';
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';
import CreateShreddedProductForm from './CreateShreddedProductForm';

export const CreateShreddedProductDialog = (props) => {
    const { isOpen, setIsOpen, translations, fetchStorageProduct } = props;

    const handleSubmit = async (params) => {
        const rest = getAxiosInstance();

        try {
            if (params.StorageSize) {
                params.StorageSize = parseInt(params.StorageSize) * 1073741824;
            }
            const res = await rest.post(`/products/storageProduct/create`, {
                ...params,
            });
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `${
                        res && res.data
                            ? res.data.message
                            : res && res.message
                            ? res.message
                            : 'Cannot create shredded product.'
                    }`,
                    options: {
                        variant: 'success',
                    },
                });
                setIsOpen(false);
                fetchStorageProduct();
                return true;
            } else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning',
                    },
                });
                return false;
            }
        } catch (error) {
            return false;
        }
    };

    return (
        <>
            <Dialog
                onClose={() => setIsOpen(false)}
                aria-labelledby="customized-dialog-title"
                open={isOpen}
                fullWidth={true}
                maxWidth={'sm'}
            >
                <DialogTitle>
                    {translations['create_shredded_storage_product'] ?? `Create shredded storage product`}{' '}
                </DialogTitle>
                <Grid container>
                    <CreateShreddedProductForm handleSubmit={handleSubmit} />
                </Grid>
            </Dialog>
        </>
    );
};
